export class ShortCutKey
{

    public  initialize(){
     document.body.addEventListener('keydown', (ev)=>this.onKeyDown(ev));
    }

    //キーコードに対してハンドラ1つだけ許可
    private hash: { [key: string]: ()=>boolean} = {};

    public add(keyCode:string, handler:()=>boolean){
        this.hash[keyCode] = handler;
    }

    public remove(keyCode:string, handler:()=>boolean){
        //delete this.hash[keyCode];
        //削除後もキーは残す(ブラウザのデフォルト動作を回避したい)=>ファンクションキーを予約済みに変更
        //コンポーネント切替の際に新しい方のaddが先に呼ばれてしまうのでhandlerの一致を確認する
        if (this.hash[keyCode]!= null && this.hash[keyCode]== handler )
        {
            this.hash[keyCode] = null;
        }
    }

    public enabled : boolean = true;
    public filter: (key:string) => boolean;
    public onKeyDown(ev: KeyboardEvent){        
        var handled = ev.key.startsWith("F") && ev.key != "F"; //ファンクションキーを予約済みにする
        if (ev.key in this.hash){
            if (this.hash[ev.key] != null && this.enabled && (this.filter == null || this.filter(ev.key))) {
                this.hash[ev.key]();
                handled = true;
            }
        } 
        if (handled){
            ev.preventDefault();
        }
    }
}